import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PricingPlansAdmin from "./PricingPlansAdmin";
import SubscriptionPlansAdmin from "./SubscriptionPlansAdmin";
import AddOnPricingAdmin from "./AddOnPricingAdmin";
import OrgCustomPricing from "./OrgCustomPricing";
import React from "react";

export default function PricingManagement() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-1">Pricing Management</h2>
        <p className="text-muted-foreground text-sm">
          Manage subscription tiers, usage rates, add-ons and per-organisation custom pricing.
        </p>
      </div>

      <Tabs defaultValue="subscriptions">
        <TabsList>
          <TabsTrigger value="subscriptions">Subscription Plans</TabsTrigger>
          <TabsTrigger value="usage">Usage Rates</TabsTrigger>
          <TabsTrigger value="addons">Add-ons</TabsTrigger>
          <TabsTrigger value="custom">Custom Pricing</TabsTrigger>
        </TabsList>
        <TabsContent value="subscriptions" className="pt-4">
          <SubscriptionPlansAdmin />
        </TabsContent>
        <TabsContent value="usage" className="pt-4">
          <PricingPlansAdmin />
        </TabsContent>
        <TabsContent value="addons" className="pt-4">
          <AddOnPricingAdmin />
        </TabsContent>
        <TabsContent value="custom" className="pt-4">
          <OrgCustomPricing />
        </TabsContent>
      </Tabs>
    </div>
  );
}
